var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckDoubleFill = function SvgCheckDoubleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.142 13.585 1.27 1.27 7.62-7.619 1.273 1.273-8.892 8.892-5.728-5.728 1.273-1.272 1.912 1.912 1.272 1.271Zm.002-2.545L16.6 6.582l1.27 1.269-4.457 4.458zm-2.545 5.09L8.328 17.4 2.6 11.674l1.273-1.272 1.271 1.271v.001z"
  })));
};
export default SvgCheckDoubleFill;